<template>
  <div>
    <div class="document">
      <img src="../../../assets/img/logo/PinkNannies-RGB-Horizontal.svg" alt="" class="center" style="width: 210px; padding-bottom: 30px;">
      <h3 style="text-align: center;">Nanny Handbook</h3>
      <hr>

      <hr>
      <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
      <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
      <h4 v-if="signature" style="font-family: 'Arizonia'; text-transform: none;">{{ signature }}</h4>
      <h4 v-if="!signature">___________________</h4>
      <p v-if="document.status == 'Signed'">{{ document.signing_name }}</p>
      <div v-if="!document.signing_name">
        <input type="text" class="form-control" v-model="signature" style="max-width: 500px;">
        <label v-if="!signature" class="mt-1">Please type your name.</label>
        <div>
          <button v-if="!signature" class="mylisting-button disabled-button mt-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
          <button v-if="signature" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
        </div>
      </div>
      <!-- <p>{{ document }}</p> -->
      <!-- <button @click="deleteDocument()" class="mylisting-button danger-button">Delete</button> -->
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['document'],
  data() {
    return {
      signature: '',
    }
  },
  created() {
    this.signature = this.document.signing_name
  },
  methods: {
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteDocument() {
      axios.delete(`/api/documents/${this.document.id}/`)
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/candidates/documents/NannyHandbook.vue